import { render, staticRenderFns } from "./BuyProductHistory.vue?vue&type=template&id=59d6c102&scoped=true&"
import script from "./BuyProductHistory.vue?vue&type=script&lang=js&"
export * from "./BuyProductHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyProductHistory.vue?vue&type=style&index=0&id=59d6c102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6c102",
  null
  
)

export default component.exports